import { render } from "./BackupsApp.vue?vue&type=template&id=1b2ea100"
import script from "./BackupsApp.vue?vue&type=script&lang=js"
export * from "./BackupsApp.vue?vue&type=script&lang=js"

import exportComponent from "C:\\hd\\git\\enuve\\app-cliente\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__